import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section style={{ background: 'linear-gradient(to bottom, #f5ede0, #faf7f2)' }} className="py-16 md:py-20">
      <div className="w-full px-4 sm:px-6 lg:px-12 xl:px-20 max-w-5xl mx-auto">

        {/* ── Section Header ── */}
        <div className="flex items-center justify-center gap-4 mb-12">
          <div className="h-px flex-1 max-w-[80px]" style={{ background: '#c9a96e' }}></div>
          <i className="ri-flower-line text-base" style={{ color: '#c9a96e' }}></i>
          <h2
            className="font-bold text-center px-2"
            style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.6rem', color: '#2c1a0e' }}
          >
            About Faasley
          </h2>
          <i className="ri-flower-line text-base" style={{ color: '#c9a96e' }}></i>
          <div className="h-px flex-1 max-w-[80px]" style={{ background: '#c9a96e' }}></div>
        </div>

        {/* Decorative divider */}
        <div className="flex items-center justify-center gap-2 mb-12">
          <div className="h-px w-24" style={{ background: '#e8d5b7' }}></div>
          <div className="w-1.5 h-1.5 rounded-full" style={{ background: '#c9a96e' }}></div>
          <div className="h-px w-24" style={{ background: '#e8d5b7' }}></div>
        </div>

        {/* ── ROW 1: CEO text left, photo right ── */}
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center mb-14">
          {/* Left: CEO text */}
          <div>
            <h3
              className="font-bold mb-4"
              style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.35rem', color: '#2c1a0e' }}
            >
              About the CEO – Kamini Thakur
            </h3>
            <p className="text-sm leading-relaxed mb-3" style={{ color: '#5c3d1e' }}>
              Kamini Thakur, the visionary behind Faasley Foods, is a passionate entrepreneur with a strong background in business management and product development.
            </p>
            <p className="text-sm leading-relaxed mb-3" style={{ color: '#5c3d1e' }}>
              With years of experience in handling operations, strategy, and people, she brings a perfect blend of discipline and creativity into the brand.
            </p>
            <p className="text-sm leading-relaxed" style={{ color: '#5c3d1e' }}>
              Her journey started with a deep understanding of market needs and a desire to create something authentic and meaningful. Having worked across multiple domains and led business initiatives, she understands both the operational and emotional aspects of building a brand.
            </p>
          </div>

          {/* Right: Kamini photo */}
          <div className="rounded-2xl overflow-hidden border" style={{ borderColor: '#e8d5b7' }}>
            <img
              src="https://storage.readdy-site.link/project_files/c44a33b9-73a7-4f29-8c86-80a04dae53c1/5cb346ab-a7f1-4cf6-953f-cf38d742223f_Kamini.jpg?v=7ff1f630b615292716d05c68d8042a2b"
              alt="Kamini Thakur, Founder & CEO"
              className="w-full object-cover object-top"
              style={{ maxHeight: '320px' }}
            />
          </div>
        </div>

        {/* Decorative divider between rows */}
        <div className="flex items-center justify-center gap-2 mb-14">
          <div className="h-px w-32" style={{ background: '#e8d5b7' }}></div>
          <i className="ri-seedling-line text-sm" style={{ color: '#c9a96e' }}></i>
          <div className="h-px w-32" style={{ background: '#e8d5b7' }}></div>
        </div>

        {/* ── ROW 2: Products photo left, brand story right ── */}
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center mb-14">
          {/* Left: Products image */}
          <div className="rounded-2xl overflow-hidden border" style={{ borderColor: '#e8d5b7' }}>
            <img
              src="https://static.readdy.ai/image/3301efb4abc894ce1097fc48d2d46708/6cabdef9482c1e4e3a79baae13ecbe41.png"
              alt="Faasley Products"
              className="w-full object-cover"
              style={{ maxHeight: '340px' }}
            />
          </div>

          {/* Right: Brand story */}
          <div>
            <h3
              className="font-bold mb-4 leading-snug"
              style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.35rem', color: '#2c1a0e' }}
            >
              About Faasley —<br />The Story Behind the Brand
            </h3>
            <p className="text-sm leading-relaxed mb-3" style={{ color: '#5c3d1e' }}>
              Faasley Foods was born out of a simple yet powerful idea — to bring authentic, high-quality, and thoughtfully crafted food products to people who value taste and health.
            </p>
            <p className="text-sm leading-relaxed mb-4" style={{ color: '#5c3d1e' }}>
              The brand represents a journey of passion, patience, and precision. From selecting the right ingredients to maintaining hygiene and quality, every product is created with deep attention and care.
            </p>
            <ul className="space-y-1.5 mb-5">
              {[
                'Faasley is not just a food brand — it is a reflection of:',
                'Traditional taste',
                'Modern presentation',
                'Trust and purity',
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-2 text-sm" style={{ color: '#5c3d1e' }}>
                  <span className="mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: '#c9a96e' }}></span>
                  {item}
                </li>
              ))}
            </ul>
            <p
              className="text-sm leading-relaxed italic"
              style={{ color: '#7a4f2a', fontFamily: "'Playfair Display', serif" }}
            >
              The goal is to build a brand that stands for "Good Food, Good Mood" — a lifestyle, not just a product.
            </p>
          </div>
        </div>

        {/* ── Bottom divider + tagline ── */}
        <div className="flex items-center gap-4 mb-6">
          <div className="h-px flex-1" style={{ background: '#e8d5b7' }}></div>
          <i className="ri-flower-line text-base" style={{ color: '#c9a96e' }}></i>
          <div className="h-px flex-1" style={{ background: '#e8d5b7' }}></div>
        </div>

        <div className="text-center">
          <p
            className="font-bold mb-6"
            style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.3rem', color: '#2c1a0e' }}
          >
            Crafted with Love &amp; Care
          </p>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 font-semibold px-7 py-3 rounded-md text-sm transition-all whitespace-nowrap"
            style={{ background: '#3b2010', color: '#fff' }}
          >
            Read Full Story
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

      </div>
    </section>
  );
}
